/**
 * Checks if the given element is an HTML input element.
 *
 * @param {Element} element - The DOM element to check.
 * @returns {boolean} - Returns true if the element is an input element, otherwise false.
 */
export default (element) => {
    return element && element.localName && element.localName.toLowerCase() === 'input';
};
